import { Typography } from '@mui/material'
import tw from 'twin.macro'
import { ClientPublicWrapper } from 'src/components/layout/client/ClientPublicWrapper'
import { Navigate, useParams } from 'react-router-dom'
import { CLIENT_ROUTES } from 'src/constants/routes'
import { AirspaceSelectCityForm } from 'src/components/pre-auth/airspace-select-city-form/AirspaceSelectCityForm'

export const PreOnboardingAirspacePage = () => {
  const params = useParams()

  if (!params?.partnerName || params.partnerName !== 'airspace') {
    return <Navigate to={CLIENT_ROUTES.NOT_FOUND_URL} />
  }

  return (
    <ClientPublicWrapper>
      <div css={tw`py-2`}>
        <Typography variant="h2" css={tw`my-2`}>
          Start Your Airspace Driver Onboarding
        </Typography>
        <Typography css={tw`mb-6 max-w-[320px] text-shades-400`}>
          Thank you for your interest in driving with Airspace! To get started, please tell us where
          you're located.
        </Typography>
        <AirspaceSelectCityForm />
        <Typography css={tw`mt-6 text-center text-shades-400`}>
          Questions? Email us at
          <br />
          <a href="mailto:partners@airspace.com" target="_blank">
            <Typography
              css={tw`cursor-pointer underline inline-block text-center text-primary-500`}
              variant="h4"
            >
              partners@airspace.com
            </Typography>
          </a>
        </Typography>
      </div>
    </ClientPublicWrapper>
  )
}
